import {
  BookIcon,
  ChartCircleIcon,
  DocumentChartsIcon,
  PaperIcon,
  PostHiringInfoCard,
  PostHiringStatisticsCard,
  Work2Icon,
} from "@cpj-ai/panel-npm-package";
import { GetEmployementOverviewQuery } from "@graphql/generated";
import { Spinner } from "@heroui/react";
import dayjs from "dayjs";
import { useMemo } from "react";

interface IOverviewTabContentProps {
  data?: GetEmployementOverviewQuery;
  loading?: boolean;
}

const OverviewTabContent = ({ data, loading }: IOverviewTabContentProps) => {
  const statisticsData = useMemo(() => {
    return [
      {
        icon: <Work2Icon className="w-6 h-6 fill-cyan-700 -mt-0.5" />,
        value: String(dayjs().diff(dayjs(data?.me?.currentEmployement?.cooperations?.startAt), "day")),
        label: "Cooperation Day",
        iconBgColor: "bg-cyan-800",
      },
      {
        icon: <BookIcon className="w-6 h-6 stroke-pink-500 -mt-0.5" />,
        value: String(data?.academy?.courses?.totalCount ?? "-"),
        label: "Completed Trainings",
        iconBgColor: "bg-pink-600",
      },
      {
        icon: <ChartCircleIcon className="w-6 h-6 stroke-green-600 -mt-0.5" />,
        value: String(data?.me?.currentEmployement?.cooperations?.employerSatisfactionRate ?? "-"),
        label: "Employer SatisfactionRate",
        iconBgColor: "bg-green-700",
      },
      {
        icon: <DocumentChartsIcon className="w-6 h-6 stroke-yellow-500 -mt-0.5" />,
        value: "0",
        label: "Monthly report",
        iconBgColor: "bg-yellow-600",
      },
    ];
  }, [data]);

  const contractInfo = useMemo(
    () => [
      {
        label: "Job Title:",
        value: data?.me?.currentEmployement?.cooperations?.jobPosition?.title ?? "-",
      },
      {
        label: "Contract Type :",
        value:
          data?.me?.currentEmployement?.cooperations?.jobPosition?.contractType
            ?.replace("_", " ")
            .toLocaleLowerCase() ?? "-",
      },
      {
        label: "Employment Status :",
        value: data?.me?.currentEmployement?.cooperations?.status?.replace("_", " ").toLocaleLowerCase(),
      },
      {
        label: "Work Experience :",
        value: data?.me?.currentEmployement?.cooperations?.jobPosition?.workExperienceYearsRange?.[0]
          ? `${data?.me?.currentEmployement?.cooperations?.jobPosition?.workExperienceYearsRange?.[0]}+`
          : "-",
      },
      {
        label: "Hired date :",
        value: data?.me?.currentEmployement?.cooperations?.createdAt
          ? dayjs(data?.me?.currentEmployement?.cooperations?.createdAt).format("DD/MM/YYYY")
          : "-",
      },
      {
        label: "Start Date :",
        value: data?.me?.currentEmployement?.cooperations?.startAt
          ? dayjs(data?.me?.currentEmployement?.cooperations?.startAt).format("DD/MM/YYYY")
          : "-",
      },
      {
        label: "End Date :",
        value: data?.me?.currentEmployement?.cooperations?.endAt
          ? dayjs(data?.me?.currentEmployement?.cooperations?.endAt).format("DD/MM/YYYY")
          : "-",
      },
    ],
    [data],
  );

  if (loading)
    return (
      <div className="flex  justify-center items-center ">
        <Spinner color="primary" />
      </div>
    );

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 md:gap-5 overflow-">
        {statisticsData.map((item) => (
          <PostHiringStatisticsCard key={item.label} {...item} />
        ))}
      </div>

      <div className="flex flex-col gap-6 mt-5">
        <PostHiringInfoCard
          icon={<PaperIcon className="w-6 h-6 -mt-0.5" />}
          label="Contract information :"
          data={contractInfo}
        />
      </div>
    </div>
  );
};

export default OverviewTabContent;
